import React, { useState, useEffect } from 'react';
import Select from 'react-select';
import { RiRefreshLine } from 'react-icons/ri';
import { FaSave, FaChevronLeft } from 'react-icons/fa';
import { IoSearch } from 'react-icons/io5';
import { GrDocumentUpdate } from 'react-icons/gr';
import { MdOutlineRemoveCircleOutline } from 'react-icons/md';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import Modal from 'react-bootstrap/Modal';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';

const LeaseGeneralInvoice = () => {
  const [activeTab, setActiveTab] = useState(0);
  const [gridVisibility, setGridVisibility] = useState([true, false, false]);
  const [attachmentList, setAttachmentList] = useState([{ id: Date.now(), fileName: '', remarks: '' }]);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);

  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };

  // Invoice List Grid Columns
  const [invoiceColDefs, setInvoiceColDefs] = useState([
    { headerName: 'Voucher No', field: 'voucherNo', filter: true, floatingfilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Posting Date', field: 'postingDate', filter: true, floatingfilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Lease No', field: 'leaseNo', filter: true, floatingfilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Property', field: 'property', filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
    { headerName: 'Unit No', field: 'unitNo', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
    { headerName: 'Tenant', field: 'tenant', filter: true, floatingfilter: true, suppressMovable: true, width: 150 },
    { headerName: 'Amount', field: 'amount', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
    { headerName: 'VAT', field: 'vat', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
    { headerName: 'Total', field: 'total', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
    { headerName: 'Received', field: 'received', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
    { headerName: 'CN Amount', field: 'cnAmount', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
  ]);

  // Transaction Details Grid Columns
  const [transactionColDefs, setTransactionColDefs] = useState([
    { headerName: 'Account Code', field: 'accountCode', filter: true, floatingfilter: true, suppressMovable: true, width: 120 },
    { headerName: 'Account Name', field: 'accountName', filter: true, floatingfilter: true, suppressMovable: true, width: 200 },
    { headerName: 'Credit', field: 'credit', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
    { headerName: 'Tax', field: 'tax', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
    { headerName: 'VAT', field: 'vat', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
    { headerName: 'Total', field: 'total', filter: true, floatingfilter: true, suppressMovable: true, width: 100 },
    { headerName: 'Narration', field: 'narration', filter: true, floatingfilter: true, suppressMovable: true, width: 200 },
  ]);

  // Sample data for grids
  const invoiceData = [
    {
      voucherNo: 'LGIBH250821...',
      postingDate: '21-Aug-2025',
      leaseNo: 'LV-25-00231',
      property: 'AL YUSUFIYA APART...',
      unitNo: 'Y-14 (877/2)',
      tenant: 'KHAYBER TRADING...',
      amount: '47.640',
      vat: '4.760',
      total: '52.400',
      received: '0.000',
      cnAmount: '0.000',
    },
    {
      voucherNo: 'LGIBH250821...',
      postingDate: '21-Aug-2025',
      leaseNo: 'LV-25-00267',
      property: 'MOHAMMEDIA GA...',
      unitNo: '1368',
      tenant: 'MICHAEL ROBERTS',
      amount: '292.990',
      vat: '0.000',
      total: '292.990',
      received: '0.000',
      cnAmount: '0.000',
    },
  ];

  const transactionData = [{ accountCode: '', accountName: '', credit: '0.000', tax: 'None', vat: '0.000', total: '0.000', narration: '' }];

  const handleFileSelect = (event, id) => {
    const file = event.target.files[0];
    if (file) {
      setAttachmentList((prevList) => [
        ...prevList.map((attachment) => (attachment.id === id ? { ...attachment, fileName: file.name, file: file } : attachment)),
        { id: Date.now(), fileName: '', remarks: '' },
      ]);
    }
  };

  const handleView = (file) => {
    if (file && file instanceof File) {
      setPreviewImage(URL.createObjectURL(file));
      setPreviewModal(true);
    } else {
      console.error('No valid file to preview');
    }
  };

  const handleDelete = (id) => {
    const updatedList = attachmentList.filter((attachment) => attachment.id !== id);
    setAttachmentList(updatedList);
  };

  return (
    <div className="p-5">
      <div className="border-box2 p-2" style={{ borderRadius: '8px' }}>
        <div className="row">
          <div className="col-8 mt-3" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(250px, 1fr))', gap: '15px' }}>
            <div className="d-flex">
              <label htmlFor="property" className="form-label pt-1 start">
                Property
              </label>
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 5,
                  padding: 9,
                })}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                    color: state.isFocused ? '#000 ' : '#000',
                    ':hover': {
                      backgroundColor: '#F5F5F5',
                      color: '#000 ',
                    },
                  }),
                }}
                className="w-75 p-0"
                placeholder="--ALL--"
              />
            </div>
            <div className="d-flex">
              <label htmlFor="dateFrom" className="form-label pt-1 start">
                Date From
              </label>
              <input type="date" className="p-2 form-control w-75" name="dateFrom" defaultValue="2025-07-27" />
            </div>
            <div className="d-flex">
              <label htmlFor="unit" className="form-label pt-1 start">
                Unit
              </label>
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 5,
                  padding: 9,
                })}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                    color: state.isFocused ? '#000 ' : '#000',
                    ':hover': {
                      backgroundColor: '#F5F5F5',
                      color: '#000 ',
                    },
                  }),
                }}
                className="w-75 p-0"
                placeholder="--ALL--"
              />
            </div>
            <div className="d-flex">
              <label htmlFor="dateTo" className="form-label pt-1 start">
                To
              </label>
              <input type="date" className="p-2 form-control w-75" name="dateTo" defaultValue="2025-08-27" />
            </div>
            <div className="d-flex">
              <label htmlFor="leaseNo" className="form-label pt-1 start">
                Lease No
              </label>
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 5,
                  padding: 9,
                })}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                    color: state.isFocused ? '#000 ' : '#000',
                    ':hover': {
                      backgroundColor: '#F5F5F5',
                      color: '#000 ',
                    },
                  }),
                }}
                className="w-75 p-0"
                placeholder="--ALL--"
              />
            </div>
            <div className="d-flex align-items-center">
              <input type="text" className="p-2 form-control" placeholder="Search term..." />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex gap-2">
              <div className="mainbtn flex-end gap-2 w-50">
                <FaSave color="#fff" className="center mt-1 mx-2" />
                <div className="center">Save</div>
              </div>
              <div className="mainbtnGry flex-end gap-2 w-50">
                <IoSearch color="#fff" className="center mt-1 mx-2" />
                <div className="center">Search</div>
              </div>
            </div>
            <div className="d-flex mt-1 gap-2">
              <div className="mainbtnSecondary flex-end gap-2 w-50">
                <FaChevronLeft color="#fff" className="center mt-1 mx-2" />
                <div className="center">Back</div>
              </div>
              <div className="mainbtnRed flex-end gap-2 w-50">
                <RiRefreshLine color="#fff" className="center mt-1 mx-2" />
                <div className="center">Reset</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="border-box2 my-3 p-3" style={{ borderRadius: '8px' }}>
        <div className="nav nav-pills overslid d-flex gap-4">
          <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
            Invoice List
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
            Transaction Details
          </div>
          <div className={`dashitems sidebar-text center ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
            Attachments
          </div>
        </div>
      </div>

      {gridVisibility[0] && (
        <div>
          <div className="ag-theme-quartz" style={{ height: 500, suppressMovable: true, width: '100%' }}>
            <AgGridReact
              columnDefs={invoiceColDefs}
              rowData={invoiceData}
              suppressRowClickSelection={true}
              getRowStyle={(params) => {
                return params.node.rowIndex % 2 === 0 ? { background: '#F0EDF5' } : { background: '#fff' };
              }}
            />
          </div>
        </div>
      )}

      {gridVisibility[1] && (
        <div className="border-box2 p-3" style={{ borderRadius: '8px' }}>
          <div className="form-group mb-4" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))', gap: '20px' }}>
            <div className="d-flex">
              <label htmlFor="accountCode" className="form-label pt-1 start">
                Account Code
              </label>
              <input type="text" className="p-2 form-control w-75" name="accountCode" />
              <button className="mainbtn ms-2 px-2">
                <IoSearch color="#fff" />
              </button>
            </div>
            <div className="d-flex">
              <label htmlFor="currency" className="form-label pt-1 start">
                Currency
              </label>
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 5,
                  padding: 9,
                })}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                    color: state.isFocused ? '#000 ' : '#000',
                    ':hover': {
                      backgroundColor: '#F5F5F5',
                      color: '#000 ',
                    },
                  }),
                }}
                className="w-75 p-0"
                placeholder="BHD"
              />
            </div>
            <div className="d-flex">
              <label htmlFor="transactionDate" className="form-label pt-1 start">
                Transaction Date
              </label>
              <input type="date" className="p-2 form-control w-75" name="transactionDate" defaultValue="2025-08-27" />
            </div>
            <div className="d-flex">
              <label htmlFor="tenant" className="form-label pt-1 start">
                Tenant
              </label>
              <input type="text" className="p-2 form-control w-75" name="tenant" />
            </div>
            <div className="d-flex">
              <label htmlFor="conRate" className="form-label pt-1 start">
                Con Rate
              </label>
              <input type="text" className="p-2 form-control w-75" name="conRate" defaultValue="1.0000" />
            </div>
            <div className="d-flex">
              <label htmlFor="type" className="form-label pt-1 start">
                Type
              </label>
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 5,
                  padding: 9,
                })}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                    color: state.isFocused ? '#000 ' : '#000',
                    ':hover': {
                      backgroundColor: '#F5F5F5',
                      color: '#000 ',
                    },
                  }),
                }}
                className="w-75 p-0"
                placeholder="--Select--"
              />
            </div>
            <div className="d-flex">
              <label htmlFor="property" className="form-label pt-1 start">
                Property
              </label>
              <input type="text" className="p-2 form-control w-75" name="property" />
            </div>
            <div className="d-flex">
              <label htmlFor="fxAmount" className="form-label pt-1 start">
                Fx Amount
              </label>
              <input type="text" className="p-2 form-control w-75" name="fxAmount" defaultValue="0.0000" />
            </div>
            <div className="d-flex">
              <label htmlFor="transactionType" className="form-label pt-1 start">
                Transaction Type
              </label>
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 5,
                  padding: 9,
                })}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                    color: state.isFocused ? '#000 ' : '#000',
                    ':hover': {
                      backgroundColor: '#F5F5F5',
                      color: '#000 ',
                    },
                  }),
                }}
                className="w-75 p-0"
                placeholder="-- Select --"
              />
            </div>
            <div className="d-flex">
              <label htmlFor="unitNo" className="form-label pt-1 start">
                Unit No
              </label>
              <input type="text" className="p-2 form-control w-75" name="unitNo" />
            </div>
            <div className="d-flex">
              <label htmlFor="amountDr" className="form-label pt-1 start">
                Amount (Dr)
              </label>
              <input type="text" className="p-2 form-control w-75" name="amountDr" defaultValue="0.000" />
            </div>
            <div className="d-flex">
              <label htmlFor="taxCode" className="form-label pt-1 start">
                Tax Code
              </label>
              <Select
                theme={(theme) => ({
                  ...theme,
                  borderRadius: 5,
                  padding: 9,
                })}
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                  option: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                    color: state.isFocused ? '#000 ' : '#000',
                    ':hover': {
                      backgroundColor: '#F5F5F5',
                      color: '#000 ',
                    },
                  }),
                }}
                className="w-75 p-0"
                placeholder="None"
              />
            </div>
            <div className="d-flex">
              <label htmlFor="leaseNo" className="form-label pt-1 start">
                Lease No
              </label>
              <input type="text" className="p-2 form-control w-75" name="leaseNo" />
            </div>
            <div className="d-flex align-items-center gap-2">
              <input className="form-check-input" type="checkbox" id="taxInclusive" style={{ width: '20px', height: '20px' }} />
              <label className="form-check-label" htmlFor="taxInclusive">
                Tax Inclusive
              </label>
              <button className="mainbtnSecondary ms-auto px-3">Apply To Rows</button>
            </div>
          </div>

          <div className="mb-3">
            <label htmlFor="narration" className="form-label start">
              Narration
            </label>
            <textarea className="form-control" id="narration" rows="3"></textarea>
          </div>

          <div className="ag-theme-quartz" style={{ height: 200, suppressMovable: true, width: '100%' }}>
            <AgGridReact
              columnDefs={transactionColDefs}
              rowData={transactionData}
              suppressRowClickSelection={true}
              getRowStyle={(params) => {
                return params.node.rowIndex % 2 === 0 ? { background: '#F0EDF5' } : { background: '#fff' };
              }}
            />
          </div>

          <div className="d-flex justify-content-center mt-3" style={{ background: '#D9D9D9', borderRadius: '0px 0px 8px 8px', padding: '10px' }}>
            <div className="d-flex gap-4">
              <div className="d-flex gap-2">
                <div className="totalhead center">0.00</div>
              </div>
              <div className="d-flex gap-2">
                <div className="totalhead center">0.00</div>
              </div>
              <div className="d-flex gap-2">
                <div className="totalhead center">0.00</div>
              </div>
            </div>
          </div>
        </div>
      )}

      {gridVisibility[2] && (
        <div className="border-box2 p-4" style={{ borderRadius: '8px' }}>
          <div className="col d-flex justify-content-between">
            <input className="form-Input w-100" placeholder="Enter Description" />
          </div>
          <div className="pt-2">
            <table>
              <thead className="dynoTable">
                <tr>
                  <th>File Name</th>
                  <th>Remarks</th>
                  <th>Upload</th>
                  <th>View</th>
                  <th>Delete</th>
                </tr>
              </thead>
              <tbody>
                {attachmentList?.map((attachment, index) => (
                  <tr key={attachment.id}>
                    <td className="m-0 p-0">
                      <input className="p-0" type="text" disabled value={attachment.fileName} style={{ width: '600px' }} />
                    </td>
                    <td>
                      <input
                        type="text"
                        value={attachment.remarks}
                        onChange={(e) => {
                          const updatedList = attachmentList?.map((item) => (item.id === attachment.id ? { ...item, remarks: e.target.value } : item));
                          setAttachmentList(updatedList);
                        }}
                        style={{ width: '600px' }}
                      />
                    </td>
                    <td>
                      <button className="mainbtn " onClick={() => document.getElementById(`fileInput-${attachment.id}`).click()} type="submit">
                        <div>Upload</div>
                      </button>
                      <input
                        type="file"
                        accept="image/*"
                        style={{ display: 'none' }}
                        onChange={(e) => handleFileSelect(e, attachment.id)}
                        id={`fileInput-${attachment.id}`}
                      />
                    </td>
                    <td>
                      <button className="mainbtnRed " onClick={() => handleView(attachment.file)} disabled={!attachment.fileName}>
                        <div>View</div>
                      </button>
                    </td>
                    <td>
                      <button onClick={() => handleDelete(attachment.id)} disabled={!attachment.fileName} className="mainbtnSecondary">
                        <div>Delete</div>
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>Image Preview</Modal.Title>
        </Modal.Header>
        <Modal.Body>{previewImage && <img src={previewImage} alt={previewImage} style={{ width: '100%', objectFit: 'cover' }} />}</Modal.Body>
      </Modal>
    </div>
  );
};

export default LeaseGeneralInvoice;
